<template>
  <page-view :key="$route.hash" :title="$t('collections.title')" backLink="/dashboard" backText="Back to Dashboard">
    <template v-slot:header-right>
      <Button @click="$router.push('/collection/create')">{{ $t('collections.new_collection') }}</Button>
    </template>
    <template v-if="state === ''">
      <table-list>
        <tr class="header">
          <th class="w-100p w-md-50p">Collection</th>
          <th class="w-20p only-desktop ta-c">Featured</th>
          <th class="w-20p only-desktop ta-c">Published</th>
          <th class="w-20p only-desktop ta-c">Tags</th>
          <th class="w-10p extra-padding"></th>
        </tr>
        <a :href="`/collection/${collection.id}`" @click.prevent="handleLink($event, `/collection/${collection.id}`)" v-for="collection in collections" :key="collection.id">
          <td class="strong ellipsis">
            <div class="blue">{{ collection.metadata.title }}</div>
            <div class="only-mobile gray">
              <strong>Featured:</strong> {{ collection.play.featured ? 'Yes' : 'No' }}
              <strong>Published:</strong> {{ collection.play.published ? 'Yes' : 'No' }}
            </div>
          </td>
          <td class="ta-c only-desktop ">{{ collection.play.featured ? 'Yes' : 'No' }}</td>
          <td class="ta-c only-desktop">{{ collection.play.published ? 'Yes' : 'No' }}</td>
          <td class="ta-c only-desktop">{{ collection.tags ? collection.tags.length : 0 }}</td>
          <td class="extra-padding blue"><i class="arrow mdi mdi-chevron-right"></i></td>
        </a>
      </table-list>
    </template>
    <template v-else-if="state === 'loading'">
      <div class="d-f f-1 ai-c jc-c">
        <div class="loading-spinner large"></div>
      </div>
    </template>
  </page-view>
</template>

<script>

import TableList from '@/components/Lists/Table.vue';

export default {
  components: {
    TableList,
  },
  computed: {
    /**
     * Return list of collections
     * @returns {Array}
     */
    collections() {
      return this.$store.getters['Collections/list'];
    },
  },
  methods: {
    /**
     * Get collections
     * @returns {Void}
     */
    async getCollections() {
      await this.$store.dispatch('Collections/getCollections');
    },
  },
  data() {
    return {
      state: 'loading',
    };
  },
  async mounted() {
    await this.getCollections();
    this.state = '';
  },
};
</script>
